import { useState } from "react";
import { X } from "lucide-react";
import { API } from "../../config";
import { PreviewFeedback } from "./PreviewFeedback";

const T = { sk: { title: "Náhľady dizajnu", sub: "Takto zatiaľ vyzerá váš web. Dajte vedieť, čo sa vám páči, alebo napíšte pripomienku." },
  cs: { title: "Náhledy designu", sub: "Takhle zatím vypadá váš web. Dejte vědět, co se vám líbí, nebo napište připomínku." } };

export const ProposalPreviews = ({ token, items, lang }) => {
  const [open, setOpen] = useState(null);
  if (!items?.length) return null;
  const src = (id) => `${API}/web-design/proposal/${token}/previews/${id}`;
  const t = T[lang];
  return (
    <section className="mt-10" data-testid="proposal-previews">
      <h2 className="text-xl font-black">{t.title}</h2>
      <p className="mt-1 text-sm text-white/60">{t.sub}</p>
      <div className="mt-5 grid sm:grid-cols-2 gap-4">
        {items.map((it) => (
          <div key={it.id} className="rounded-xl overflow-hidden border border-white/10 bg-white/[0.03]">
            <button onClick={() => setOpen(it)} className="group block w-full text-left" data-testid={`proposal-preview-${it.id}`}>
              <img src={src(it.id)} alt={it.caption || t.title} loading="lazy" className="w-full aspect-[16/10] object-cover object-top group-hover:scale-[1.02] transition-transform duration-500" />
              {it.caption && <p className="px-3 py-2 text-sm text-white/75">{it.caption}</p>}
            </button>
            <PreviewFeedback token={token} item={it} lang={lang} />
          </div>
        ))}
      </div>
      {open && (
        <div className="fixed inset-0 z-[80] bg-black/85 backdrop-blur-sm flex items-center justify-center p-4" onClick={() => setOpen(null)} data-testid="proposal-preview-lightbox">
          <button className="absolute top-4 right-4 w-10 h-10 rounded-full bg-white/10 flex items-center justify-center" aria-label="Zavrieť" data-testid="proposal-preview-close"><X className="w-5 h-5" /></button>
          <figure className="max-w-5xl w-full" onClick={(e) => e.stopPropagation()}>
            <img src={src(open.id)} alt={open.caption || ""} className="w-full max-h-[80vh] object-contain rounded-lg" />
            {open.caption && <figcaption className="mt-3 text-center text-white/80">{open.caption}</figcaption>}
          </figure>
        </div>
      )}
    </section>
  );
};
